module.exports = {
  "我们为您提供了AI赚币、贷款、新币申购的功能":"We provide you with the functions of AI currency earning, loans, and new currency subscription.",
  "AI赚币介绍":"Introduction to AI Fund",
  "账户":"Account",
  "盈亏":"Profit and loss",
  "平仓时间":"Closing time",
  "止盈止损":"Take profit and stop loss",
  "止盈":"Take profit",
  "止损":"stop loss",
  "订单详情":"order details",
  "取消":"Cancel",
  "订单时间":"order time",
  "搜索币种":"Search currency",
  "选择币种":"Select currency",
  "请输入手数":"Please enter the number of lots",
  "自选":"Favourites",
  "兑换":"Exchange",
  "金额":"Amount",
  "得到":"Get",
  "兑换手续费为":"Exchange Fee",
  "立即发送":"Send immediately",
  "申请时间":"Application time",
  "接收数量":"Receive Qty.",
  "手续费":"Fee",
  "充值":"Deposit",
  "提现":"Withdraw",
  "合约交易":"Contract",
  "看涨":"Bullish",
  "看跌":"Bearish",
  "请输入数量":"Enter Qty.",
  "买入":"Buy",
  "收益":"Return",
  "杠杆":"Leverage",
  "限价":"Limit",
  "市价":"Market",
  "卖出":"Sell",
  "请输入价格":"Enter price",
  "开仓成功":"Position opened successfully",
  "交易账户":"Transaction account",
  "交易币种":"Transaction Coins",
  "交易方向":"Trading direction",
  "交易数量":"Number of transactions",
  "开仓价格":"Opening",
  "保证金":"machinesargin",
  "确认":"confirm",
  "持仓":"Position",
  "当前委托":"Pending",
  "历史记录":"History",
  "买涨":"Buy",
  "买跌":"Sell",
  "撤单":"Cancel",
  "当前价格":"Latest",
  "平仓":"Close position",
  "总量":"Total",
  "已完成":"Completed",
  "福利专区":"Welfare Zone",
  "请时刻关注福利活动，我们将不定期发布":"Please always pay attention to welfare activities, we will release them from time to time",
  "发行日期":"Issue date",
  "上市日期":"Listing date",
  "请关注":"Please pay attention",
  "公告发布":"Announcement",
  "实际到账":"Actual arrival",
  "期权交易":"Options",
  "首页":"Home",
  "提示":"Hint",
  "请用钱包APP访问":"Please use wallet APP to access",
  "矿池赚币":"Mining pool",
  "快捷买币":"Buy coins",
  "更多币种，快捷买币":"More currencies, buy coins quickly",
  "去购买":"Go buy",
  "公告":"Announcement",
  "P2P交易":"P2P trading",
  "P2P市场":"P2P market",
  "链接加密未来":"Linking to the crypto future",
  "开始交易":"Start trading",
  "交易产品":"Trading products",
  "最低手续费":"Minimum handling fee",
  "合作单位":"Co",
  "交易品种":"Trading varieties",
  "更多":"More",
  "交易品种市场趋势":"Market trends of trading products",
  "行情":"Quotes",
  "交易":"Trade",
  "货币":"Coins",
  "资产":"Assets",
  "注册":"Sign Up",
  "登录":"Sign In",
  "关于我们":"About Us",
  "联系我们":"Contact Us",
  "公告中心":"Announcement Center",
  "条款说明":"Terms and conditions",
  "用户协议":"User Agreement",
  "隐私协议":"Privacy Agreement",
  "法律声明":"Legal Notices",
  "风险告知":"Risk notification",
  "服务":"Server",
  "充币":"Deposit",
  "提币":"Withdraw",
  "新币申购":"New Coins",
  "AI赚币":"AI earn coins",
  "产品":"Product",
  "永续合约":"Perpetual",
  "期货合约":"Futures",
  "币币交易":"Exchange",
  "我的资产":"Yy assets",
  "记录":"History",
  "可用":"Available",
  "折合":"Converted",
  "私募币种":"Private placement Coins",
  "私募币种上线,您可以在这里买到您觉得有潜力的新币":"Private placement coins are online, you can buy new coins that you think have potential here",
  "名称":"Name",
  "价格":"Price",
  "4H涨跌":"4H rise and fall",
  "成交量":"Vol.",
  "操作":"Pperate",
  "为您的资产保驾护航":"Protect your assets",
  "行业领先多重安全风控体系,7*24小时全年无休平台监控，全方位保护资产 安全":"Industry-leading multiple security risk control systems, 24/7 platform monitoring, all-round protection of asset security",
  "多重":"Multiple",
  "安全风控机制":"Security risk control mechanism",
  "全球领先的交易市场":"The world's leading trading market",
  "轻松创建个人专属资产账户，探索、购买和交易全球的优质 交易品类":"Easily create a personal exclusive asset account to explore, purchase and trade high-quality trading categories around the world",
  "品种":"Variety",
  "手机PC端均可使用":"Available on both mobile and PC",
  "随时随地开始交易":"Start trading anytime, anywhere",
  "我们提供强大的图表分析工具：五十多种技术指标和盘面 分析工具。安全可靠、易于使用而又具备高阶投资者使用 的功能特点，成为在线投":"We provide powerful chart analysis tools: more than fifty technical indicators and disk analysis tools. It is safe, reliable, easy to use and has features for high-end investors, making it an online investment platform.",
  "点击下载":"Click to download",
  "安卓市场":"Android Market",
  "苹果商店":"Apple store",
  "私募币种限量上线,您可以在这里买到您觉得有潜力的新币":"A limited Number of private placement coins are online. You can buy new coins that you think have potential here.",
  "24H涨跌":"24H",
  "探索无限可能":"Explore endless possibilities",
  "新币申购功能上线":"New coins subscription function is online",
  "开始使用":"Start using",
  "AI赚币计划进行中":"AI fund plan is in progress",
  "开始AI赚币,稳定收益,高回报率,让您 躺着赚币":"Start AI fund, stable income, high return rate, let you make money without doing anything",
  "贷款功能上线":"Loan function is online",
  "当您没钱的时候,您可以申请贷款,最快 当天下发 ":"When you have no money, you can apply for a loan and it will be issued as soon as the same day",
  "新币限量上线,您可以在这里买 到您觉得有潜力的新币":"A limited Number of new coins are online. You can buy new coins that you think have potential here.",
  "模拟交易":"Demo trading",
  "限购":"Purchase limit",
  "次":"Second-rate",
  "关闭模拟":"Exit demo",
  "数量":"Qty.",
  "请输入提币地址提币手续费为":"Enter the Withdraw address. The Withdraw fee is",
  "提币手续费为":"Fee",
  "请输入提币地址":"Enter the Withdraw address",
  "我已阅读并知晓":"Agree",
  "贷款服务协议":"Loan Agreement",
	"level1": {
      "name": "Real name",
      "idcard": "Certificate type",
      "address": "Present residence address",
      "bank_Number": "Bank Number",
      "wc": "OK",
      "name_nodata": "The Name cannot be empty",
      "id_card_nodata": "The Certificate Number cannot be empty",
      "address_nodata": "The address cannot be empty",
      "bank_Number_nodata": "Bank card Number cannot be empty",
      "input-username":"Enter your real name",
      "zjhm":"Certificate Number",
      "input-idcard":"Enter your certificate Number",
      "input-address":"Enter address",
      "zjlx":"Types of valid ID",
      "qxzzjlx":"Select types of valid ID",
      "sfz":"ID card",
      "hz":"Passport",
      "jsz":"Driver's license",
      "lxz":"Certificate for studying abroad",
      "zfbzh": "Alipay account",
      "qsrzfbzh": "Enter your alipay account",
      "khh": "Account Opening",
      "qsrkhh": "Enter your account bank",
      "yhkh": "Bank card Number",
      "qsryhkh": "Enter your bank card Number",
      "zfzh": "Payment account",
      "qxzzfzh": "Choose a payment account",
      "gjlb": "Country list",
      "qxzgjlb": "Select country / Region"
    },
   "my":{
    "bindphone":"Bind Phone",
    "gqrcode":"Scan the following two-dimensional code or enter promotional code, confirm the registration",
    "mqrcode":"My Qrcode",
    "as":"Settings",
    "pc":"Junior certification",
    "ac":"Senior certification",
    "smrz":"Certification",
    "sfyz":"KYC certification",
    "mm":"My assets",
    "ms":"Share",
    "me":"My Earnings",
    "zsr":"Total revenue",
    "mp": "My promotion",
    "yqhy": "Invite friends",
    "ar":"Detailss",
    "hc":"Help",
    "nodata":"No data",
    "med": "My earnings lines",
    "aes": "All earnings(USDT)",
    "one": "One",
    "two": "Two",
    "three": "Three",
    "four": "Four",
    "ones": "One Number",
    "twos": "Two Number",
    "threes": "Three Number",
    "fours": "Four Number",
    "promotion": "total",
    "customers": "My earnings",
    "total": "Total",
    "usdt": "USDT",
    "wdzc": "My assets",
    "wdzc1":"My assets",
    "wyfx": "My Shares",
    "wdsy": "My Earnings",
    "wdtg": "My Promotion",
    "zhjl": "Orders",
    "fbjl": "OTC transaction orders",
    "zxkf": "Online Service",
    "wdxx": "My message"
   },
  "footer": {
    "home": "Home",
    "quotation": "Markets",
    "Coins": "Exchange",
    "lever": "Contracts",
    "assets": "Balances",
    "my":"Accounts",
    "lc": "USDT earn"
  },
  home:{
      user:'Common choice of users',
      start:'Start trading',
      trading:'Trading products',
      fee:'Minimum handling fee',
      co:'Co',
      varieties:'Trading varieties',
      leading:'Leading the innovation and exploration of web3',
      market:'Market trends of trading products',
      explore:'Explore endless possibilities',
      newcurrency:'The new Coins subscription function is online!',
      alimited:'New coins are online, you can buy new coins that you think have potential here',
      get_start:'Get started',
      ai_coin:'Piscina minera coin earning plan is in progress',
      ai_text:'Start earning coins with Piscina minera, stable income, high rate of return, allowing you to earn coins while lying down',
      loan:'Loan function is online',
      loan_text:'When you have no money, you can apply for a loan and it will be issued as soon as the same day',
      mobile_pc:'Used by nurses on mobile PC',
      pc_anytime:'Start trading anytime, anywhere:',
      pc_text:'We provide powerful chart analysis tools: more than fifty technical indicators and disk analysis tools. Safe, reliable, easy-to-use leverage and high leverage features have become the standard platform for online investment.',
      mobile_down:'Click to download',
      mobile_android:'Android Market',
      mobile_ios:'Apple store',
      open_text:'You can apply for a real trading account or try out a demo account for free with one third of the cost.',
      open_account:'An account',
      tocomplete:'To complete',
      'walletlogin':'Wallet Sign In',
      thedoor:'The door to investment and financial management',
      weare:'We are the most trusted place to manage digital and foreign exchange.',
      emailaddress:'Email',
      allprices:'All prices',
      chart:'Precious metals trend chart',
      gold:'Starspu is a very practical trading software. You can view the trend chart directly on the homepage.',
      more:'More practical functions',
      weprovide:'We provide you with the functions of Piscina minera Coins earning, loans, and new Coins subscription.',
      zzc:'Total assets',
      gmjy:'Start your crypto, financial gateway'
    },
    propagate:{
      ai:'Introduction to smart mining pools',
      how:'Introduction to Fund Franchise Manager',
      brick:'Brick coins',
    },
    propagatebuy:{
      joinai:'Join the smart mining pool',
      risk:'0 risk, stable returns',
      daily:'Daily earnings will be distributed to your USDT wallet account',
      zero:'Your custodial funds are at zero risk',
      youcan:'You can withdraw your funds at any time',
      airobot:'AI robot works 24/7 365*',
    },
  "index": {
    "wdzc":"My assets",
    "xsbk":"Beginner's guide",
    "dlhkck":"View after Sign In",
    "dl":"View after Sign In",
    "zxkf":"Contact Us",
    "function": "Services",
    "legal": "Fiat",
    "legaltxt": "Buy digital assets with fiat money",
    "levertxt": "An investment that is several times the amount of your ariginal fund",
    "C2C": "C2C",
    "C2Ctxt": "Two-way trade for hedging",
    "increase": "Top Gainers",
    "innovate":"Top Innovate",
    "myshop": "My shop",
    "order": "Order management",
    "myC2C": "C2C that I trade",
    "usercenter": "Personal Center",
    "myshare": "My Sharing Link",
    "releaseC2C": "Release C2C",
    "language": "Language",
    "security": "Security Center",
    "pay": "Payment method",
    "bindaddress":"Bind Withdraw address",
    "address": "Withdraw address",
    "aboutus": "About Us",
    "logout": "Sign out",
    "vol": "24H Vol.",
    "jc":"JC exchange BEAU",
    "kjcb": "Deposit",
    "zcbz": "BTC, USDT..."
  },
  "transaction": {
    "buy": "BUY",
    "sell": "SELL",
    "pwd": "Transaction password",
    "inputpass": "Password",
    "inputnum": "Amount",
    "limit": "Limit",
    "avaiable": "Available",
    "turnover": "Turnover",
    "handicap": "Handicap",
    "Number": "Qty.",
    "noNumber":"Uncompleted Qty.",
    "Numbered":"Qty. completed",
    "price": "Price",
    "marketprice": "Market",
    "cancel": "Cancel",
    "total": "All-stop trading",
    "time": "Time",
    "nomore": "No more",
    "nodata": "No details",
    "getmore": "Load more",
    "mycommission": "Orders",
    "currentbuy": "Current (Buy)",
    "currentsell": "Current (Sell)",
    "his": "History",
    "Coins": "Exchange",
    "option": "Operation",
    "wtime":"Completion time",
    "wNumber":"Qty. completed",
    "wprice":"Completion price"
  },
  "mk": {
    "high": "H",
    "low": "L",
    "vol": "24H",
    "newPrice":"Latest",
    "product":"Product",
    "name":"Name",
    "rank":"List of gains"
  },
  "deals": {
  	"issue_time":"Time",
	"issue_Number": "Number",
	"white_book": "White Paper",
	"weburl": "Url",
	"video_url": "Video",
	"introduction": "Info",
	"onhand":"1 lots =",
	"position": "Position",
    "leverorder": "Leverage orders",
    "leverposition": "Leveraged position",
    "inputprice": "Input price",
    "inputmul": "Input multiple",
    "selectmul": "Choose multiple",
    "onehand": "1 Lots =",
    "hand": "Trading lots",
    "marketval": "Market Value",
    "bond": "Bond",
    "service": "Service fee",
    "balance": "Balance",
    "type": "Type",
    "risk": "Risk Rate",
    "total": "Total profit",
    "onekey": "Closing it",
    "makemore": "(Long)",
    "makeless": "(Short)",
    "current": "Open Orders",
    "all": "All",
    "weing": "In commission",
    "tding": "Trading",
    "ping": "Closing",
    "pied": "Closed",
    "ceiled": "Withdraw",
    "weprice": "Commission price",
    "oprice": "Opening price",
    "nowprice": "Latest price",
    "zyprice": "Stop earnings price",
    "zsprice": "Stop-loss price",
    "canbond": "Available margin",
    "optime": "Opening time",
    "pgtime": "Closing time",
    "znum": "Converted Qty.",
    "gprice": "Overnight charges",
    "pcang": "Close",
    "revoke": "Withdraw",
    "fee": "Fee",
    "you":"Optimal market price"
  },
  "assets": {
    "bzxz":"Select",
    "copy": "Copy",
    "Coins": "Coins",
    "lever": "Margin",
    "legal": "French Coins",
    "curAccount": "Transaction account",
    "total": "Equivalence of assets(USDT)",
    "leverAccount": "Leverage account",
    "legalAccount": "French account",
    "avaiable": "Available",
    "lock": "Freeze",
    "conversion": "Conversion",
    "exact": "Transaction account",
    "transfer": "Transfer",
    "num": "Qty.",
    "time": "Time",
    "Details": "Details",
    "caidata": "Financial details",
    "from": "From",
    "to": "To",
    "transnum": "Number of transfers",
    "all": "All",
    "canuse": "Available",
    "pmin": "Enter the minimum Number of transfers",
    "cmoney": "Deposit",
    "tmoney": "Withdraw",
    "caddress": "Deposit address",
    "copyaddress": "Copy address",
    "a01":"Do not recharge any non-",
    "a02":"Assets to the above address，",
    "a03":"Otherwise, assets will not be recovered.",
    "a04":"Charging only supports the simple send method. Charging with other methods is temporarily unavailable. Please understand.",
    "a05":"After you recharge to the above address, you need the confirmation of the entire network node, one network confirmation and six network confirmation can withdraw money.",
    "a06":"Minimum recharge amount:",
    "a07":"The recharge of less than the minimum amount will not be Detailsed and cannot be returned.",
    "a08":"Your replenishment address will not change frequently, you can replenish; if there is any change, we will try to notify you through the network bulletin or mail.",
    "a09":"Make sure that the computer and browser are secure to prevent information from being tampered with or leaked.",
    "taddress":"Withdraw address",
    "taddressm":"Enter a Coins Withdraw address",
    "padd":"Enter or long press paste address",
    "rate":"Fee",
    "dnum":"Number of accounts arrived",
    "more":"Load more",
    "nodata":"No data",
    "search":"Search Coins",
    "yczc": "Hide assets you don't have"
  },
  "td": {
    "dDetails": "Order details",
    "oDetails": "Completed orders",
    "filter": "Filter",
    "tdtype": "Transaction type",
    "buy": "Buy",
    "sell": "Sell",
    "wantbuy": "Purchase",
    "dstatus": "Order status",
    "nofinish": "Not finished",
    "finished": "Completed",
    "ceiled": "Cancelled",
    "payed": "Paymented",
    "waitPay": "Payment to be made",
    "reset": "Reset",
    "confirm": "OK",
    "time": "Time",
    "num": "Number",
    "tdtotal": "Amount",
    "call": "Contact each other",
    "buyer": "Buyer",
    "seller": "Seller",
    "Sprice": "Unit price",
    "price": "Price",
    "ptime": "Order time",
    "cnum": "Reference Number",
    "tdceil": "Cancel Trading",
    "sureReceive": "Confirmation of receivables",
    "conPay": "Confirmation of payment",
    "ppay": "Please pay",
    "paynext": "Pay to the following account",
    "tdPrice": "Unit price",
    "tdNum": "Number",
    "payInfo": "Payment Information",
    "accountInfo": "Account Information",
    "receiver": "Payee",
    "open": "Opening Bank",
    "pcnum": "When making payment, please fill in the reference Number",
    "imPay": "I have paid",
    "tdAttion": "Reminder",
    "odCeil": "Cancellation of orders",
    "at01": "Your remittance will go directly into the seller's account, and the digital assets sold by the seller during the transaction will be protected by the platform custody.",
    "at02": "Please complete the payment within the specified time, and be sure to click 'I have paid'. After the seller confirms the receipt, the system will transfer the digital assets to your account.",
    "at03": "If the buyer cancels the order three times on the same day, it will be limited to the purchase function on that day.",
    "sureImpay": "Confirm that you have paid the seller.",
    "badClick": "Malicious clicks will freeze accounts directly.",
    "notpay": "I haven't paid the other party yet.",
    "sureDpay": "Confirm that the buyer has paid you.",
    "sureCeil": "Confirmation of Cancellation of Transactions",
    "notCeil": "If you have paid the seller, please do not cancel the transaction.",
    "dover": "The order has been completed and payment information cannot be viewed",
    "cover": "The order has been cancelled and payment information cannot be viewed",
    "payFast": "Pay the seller as soon as you confirm the payment",
    "payClick": "If you have transferred payment to the seller, please make sure to click the 'I have paid' button in the lower right corner, otherwise it may cause financial losses.",
    "pwait": "Wait for the buyer to pay.",
    "pwd": "Transaction password",
    "ppwd": "Transaction password",
    "sure": "OK",
    "alipay": "Alipay",
    "wechat": "Wechat",
    "bank": "Bank card",
    "realName": "Real Name",
    "knum": "Card Number",
    "pprice": "Unit price",
    "pnum": "Qty.",
    "min": "Minimum trading Vol.",
    "pmin": "Minimum transaction Vol.",
    "max": "Maximum trading Vol.",
    "pmax": "Maximum transaction Vol.",
    "buyNum": "Buy Qty.",
    "Coins": "Coins",
    "pmethod": "Payment method",
    "choose": "Select",
    "mysells": "My sale",
    "mybuys": "My Purchase",
    "pcoin":"Monetary unit."
  },
  "fat": {
    "mybuy": "I want to buy",
    "mysell": "I want to sell",
    "ceil": "Cancel",
    "buy": "Buy",
    "forsell":"Sale",
    "forbuy":"Purchase",
    "sell": "Sell",
    "price": "Unit price",
    "bprice": "Purchase at a price",
    "bnum": "Buy by Qty.",
    "pbtotal": "Total amount of French Coins you want to buy",
    "pstotal": "Total amount of French Coins you want to sell",
    "pbnum": "Qty. you want to buy",
    "psnum": "Qty. you want to sell",
    "allbuy": "All buy",
    "allsell": "All sell",
    "limit": "Limit",
    "tdtotal": "Amount",
    "autoceil": "s cancels automatically",
    "num": "Number",
    "submit": "Place an order",
    "pwd": "Trading password",
    "ppwd": "Trading password",
    "sure": "Confirm the order",
    "reTime": "Certified Business | Registration Time",
    "release": "Release",
    "allOrder": "Assembly Order",
    "dayOrder": "30 days order",
    "overOrder": "Completion Order",
    "rate": "Completion rate",
    "auPhone": "Mobile",
    "auName": "Real Name",
    "auHigh": "Advanced",
    "sellLine": "Sell online",
    "buyLine": "Buy online",
    "myshop": "My shop",
    "mybalance":"Merchant balance"
  },
  "auth": {
    "bh": "Rejected",
    "bhr": "Your application was rejected for the following reasons:",
    "mycenter": "Personal center",
    "test": "Authentication",
    "gotest": "To authenticate",
    "testing":"In audit",
    "tested": "Certified",
    "t1": "After certification, the Withdraw amount can be increased.",
    "t2": "C2C transactions can be conducted after certification.",
    "t3": "After certification, legal Coins transactions can be carried out",
    "name": "Name",
    "account": "Account",
    "Number": "Certificate Number",
    "pname": "Your name",
    "pnum": "ID Number",
    "id_card_face": "Upload the front of the ID card",
    "id_card_back": "Upload the back of the ID card",
    "upimg": "Upload the front and back sides of the certificate, as well as the front photos with the certificate in hand.",
    "updata": "Submit",
    "updata_again":"Submit again"
  },
  "code": {
    "mycode": "My promotion code",
    "code": "Promotion Code",
    "qrcode": "Sweep the two-dimensional code pattern above or input promotion code to confirm registration",
    "notice": "Notice",
    "about": "Relevant News"
  },
  "safe": {
    "title":"Account security",
    "center": "Security center",
    "qchc":"Clear cache",
    "yysz":"Language",
    "ssms":"Dark mode",
    "gywm":"About Us",
    "lgpwd": "Sign In Password",
    "tkmm":"Withdraw password",
    "paypwd": "payment password",
    "resetpwd": "Modify password",
    "paccount": "Your cell phone Number or Email",
    "next": "Next",
    "reset":"Modification",
    "stest": "Security verification",
    "ceil": "Cancel",
    "pcode": "Verification code",
    "send": "Code sent",
    "sure": "Confirmation",
    "newPwd": "Reset password",
    "len": "Password needs 6-20 characters",
    "ppwd": "Password",
    "reppwd": "Password again.",
    "repwd": "Reset password",
    "zpwd":"Transaction password"
  },
  "met": {
    "add": "Add way",
    "open": "Name of the opening bank",
    "bank": "Bank Account",
    "realname": "Real Name",
    "alipay": "Alipay account",
    "wename": "Wechat nickname",
    "wechat": "Wechat account",
    "save": "Save",
    "popen": "Name of the opening bank",
    "pbank": "Account Number of the opening bank",
    "pname": "Real name",
    "palipay": "Alipay account",
    "pwename": "Weixin nickname",
    "pweaccount": "Wechat account"
  },
  "ads": {
    "tas": "Ticket address",
    "address": "Address",
    "noads": "You don't have an address yet.",
    "adds": "Address",
    "padd": "Withdraw or paste address",
    "remark": "Remark",
    "cel": "Delete"
  },
  "call": {
    "callme": "Contact Us",
    "privacy": "Privacy policy"
  },
  "jc": {
    "title": "JC Conversion BEAU",
    "bind": "Bind accounts",
    "balance": "JC balance",
    "cannum": "Available JC Qty.:",
    "new": "BEAU latest price:",
    "exnum": "Exchange Qty.:",
    "pnum": "JC Qty.",
    "canex": "Convertible BEAU Qty.:≈",
    "exnow": "Immediate exchange",
    "Details": "Exchange Details",
    "exprice": "Exchange price:",
    "extime": "Exchange time",
    "not": "The Number of available integrals is insufficient",
    "usenum": "Use JC Qty.",
    "paccount": "Account Number",
    "ppwd": "Password",
    "gotd":"Transaction"
  },
  "lg": {
    "welcome":"Welcome! Please Sign In",
	  "hsa": "Have account?",
    "lgs": "Sign In",
    "lgbt": "Sign In",
    "qbdl":"Wallet Sign In",
	  "lgtel":"Mobile Sign In",
    "lgeml":"Email Sign In",
    "paccount": "Phone Number or Email",
    "ppwd": "Enter your password",
    "ppwd2": "Eonfirm your password",
    "qsryqm": "Invitation code",
    "pcode": "Verification code",
    "mepwd": "Remember passwords",
    "noaccount": "Haven't got an account yet?",
    "qregister": "Sign Up",
    "register": "Sign Up",
    "phregister": "Sign Up by phone",
    "emregister": "Sign Up by email",
    "noset": "Can not be modified after registration",
    "pphone": "Mobile phone Number",
    "next": "Next",
    "have": "Has there been a account?",
    "ceil": "Cancel",
    "msgtest": "Short Message Verification",
    "send": "Code sent",
    "sure": "OK",
    "email": "Email",
    "emtest": "Email validation",
    "scode": "Send authentication code",
    "pemcode": "Verification code",
    "ppcode": "Verification code",
    "ftpwd": "Forgot password?",
    "ftpwds": "Forget passwords",
    "ptext": "Cell phone Number or Email",
    "safetest": "Security verification",
    "sjh":"Cell-phone Number",
    "yzm":"Verification Code",
    "mm":"Password",
    "qrmm":"Confirm password",
    "mmcd":"Password length 8-12 bits",
    "language": "Language",
    "kjzc": "Contact us for quick registration",
    "kjzc1": "Can't receive CAPTCHA?",
    "kjzc2": "Quick registration",
    "wyzx": "I already know",
    "qtxyxzh": "Important: Please fill in a valid Email or mobile phone Number, which can be used to retrieve your password"
  },
  "gjrz":{
    "title":"Senior certification",
    "t1":"1. Images of less than 8 MB and in JPG, JPEG, or PNG formats are supported.",
    "t2":"2. ID document photos must be clear and shall not be modified or blocked. The personal photo, document Number, and document holder’s name must be clearly visible. ",
    "t3":"3. Photos must be taken without any headwear, and are recommended to not include the use of makeup. The facial features of the document holder should be clear and recognizable, and their arms should be fully exposed.",
    "t4":"OK",
    "bh":"Reject",
    "shz":"Under review",
    "shtg":"Approved",
    "nyrzcg":"You have been certified successfully",
    "sczjz": "Upload ID photos",
    "sczjzmz": "Upload photo of front of ID document",
    "sczjbmz": "Upload photo of back of ID document",
    "scgrqmz": "Upload of documents and personal signature"
  },
  "chongzhi":{
    "title":"Deposit",
    "cbjl": "Deposit details",
    "t1":"Qty.",
    "t2":"Enter Qty.",
    "t3":"Voucher description(Optional)",
    "t4":"Input description",
    "t5":"Voucher image",
    "t6":"OK",
    "t7":"Chain name",
    "t8":"QR code",
    "t9":"Save QR code",
    "t10":"Charging address",
    "t11":"Copy",
    "zy": "Important",
    "tips1": "Please do not top up any assets that are not in this Coins to the above address otherwise the assets cannot be retrieved",
    "tips2": "1. Wallet/platform compatibility: that is, the network is supported; if the target platform does not support your Withdraw network, the assets cannot be retrieved.",
    "tips3": "2. Your top-up network and the target platform are the same; if you choose the target address is the Ethereum network, but the top-up chooses the TRC20 smart chain, you may not be able to retrieve your digital assets.",
    "tips4": "3. Make sure your address and amount are correct before recharging.",
    "tips5": "Reminder: Due to the anonymity and privacy of the block network, once you enter the wrong information, you will lose the corresponding assets. Please check your recharge address and Qty. carefully"
  },
  "tibi":{
    "title":"Withdraw",
    "tbjl": "Withdraw details",
    "t1":"Withdraw address",
    "t2":"Enter the Withdraw address",
    "t3":"Withdraw Qty.",
    "qsrtbsl":"Enter the Qty. of Withdraw Coins",
    "t4":"Minimum",
    "t5":"Transaction password",
    "t6":"Enter the transaction password",
    "t7":"Fee",
    "t8":"Qty. transferred into the account",
    "t9":"OK",
    "sc":"Delete",
    "bj":"Edit",
    "bq": "Tag(Memo)",
    "qsrbq":"Enter the tag",
    "yhktx":"Bank card Withdraw",
    "yhmc": "Bank Name",
    "qsryhmc": "Enter the Bank name",
    "yhzh": "Bank Account ",
    "qsryhzh":"Enter the Bank account",
    "gjhkdm": "SWIFT Code",
    "qsrgjhkdm":"Enter the SWIFT Code",
    "yhdz": "Bank address",
    "qsryhdz":"Enter the Bank address",
    "skrxm": "Payee Name",
    "qsrskrxm":"Enter the Payee name",
    "skrdh": "Payee Phone",
    "qsrskrdh":"Enter the Payee phone",
    "skrdz": "Payee Address",
    "qsrskrdz":"Enter the Payee address"
  },
  "huazhuan":{
    "title":"USDT transfer",
    "t1":"Exchange account balance",
    "t2":"Margin account balance",
    "t3":"Transfer Qty.",
    "t4":"Enter Qty.",
    "t5":"Transfer direction",
    "t6":"From",
    "t7":"Exchange account",
    "t8":"To",
    "t9":"Margin account",
    "t10":"OK",
    "zf": "Payment",
    "ky": "Available",
    "dd": "Get",
    "qbdh": "Exchange All",
  },
  "banner":{
    "title": "Details"
  },
  "download":{
    "t1": "Trade anytime anywhere",
    "xz": "Download"
  },
  "xgdlmm":{
    "title": "Modify Sign In password",
    "zh":"Account",
    "zhts":"Mobile phone Number or email",
    "yzm":"Verification code",
    "yzmts":"Verification code",
    "hqyzm":"Code sent",
    "mm":"Password",
    "mmts":"Password length 6-12 characters",
    "qrmm":"Confirm password",
    "send":"Code sent",
    "qr":"OK"
  },
  "sztkmm":{
    "title":"Set Withdraw password",
    "dlmm":"Sign In password",
    "dlmmts":"Enter the Sign In password",
    "xmm":"New password",
    "mmts":"Password length 6 digits",
    "qrmm":"Confirm password",
    "qr":"OK",
    "qd": "OK",
    "sztkts": "Huit: Please go to the Security Center to set the transaction password"
  },
  "rule":{
    "title":"Product introduction",
    "title2":"Rules",
    "title3":"Activity"
  },
  "news":{
    "title":"My message",
    "ckxq":"View details",
    "gg":"Notice"
  },
  "xsbk":{
    "title":"Beginner's guide"
  },
  "search":{
    "qx":"Cancel",
    "rmss":"Hot search",
    "ss": "Search"
  },
  "wdtg":{
    "title": "Invite your best friend to",
    "yq": "Join you on commission",
    "zyj": "",
    "wdyqlj":"My invitation link",
    "wdyqm":"My invitation code",
    "schbyq":"Generate a poster invitation",
    "ljtgsy":"Total revenue",
    "ljkh":"Total users(persons)",
    "tkrs":"Number of invitations",
    "ljyj":"Cumulative commission",
    "yjmx":"Commission details",
    "ljyjjl":"Cumulative commission awards (USDT",
    "ljsy":"Total revenue",
    "ljyqjl":"Cumulative invitation awards (USTD)",
    "fxd":"Share to",
    "wxhy":"WeChat friends",
    "wxpyq":"WeChat moments",
    "bctp":"Save pictures",
    "qx":"Cancel",
    "t1": "You can take all the profits",
    "t2": "From the coin-flipping",
    "t3": "Identify the image or scam it"
  },
  "bzhl":{
    "title":"AI Fund",
    "gz":"Rules",
    "tgdd":"Escrow order",
    "zztgdzj":"Funds in custody",
    "yjjrsy":"Estimated daily",
    "ljsy":"Total revenue",
    "tgzdd":"Order in custody",
    "cljxcp":"Strategic campaign products",
    "dbxe":"Single limit",
    "rsyl":"Daily rate of return",
    "zq":"Cycle",
    "qmr":"Go and buy",
    "bbzhzc": "Account assets",
    "zcc": "Total(USDT)",
    "dd":"Orders",
    "buy":"Buy in",
    "jxcp":"Featured Products",
    "ckdd":"Check order",
    "gd":"More",
    "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
    "qtbz": "Other funds"
  },
  "bzhlgm":{
    "title":"Profits from brick removal",
    "bzhld":"Profits from brick removal USDT",
    "qtzq":"USDT 7-day cycle",
    "rsyl":"Daily return rate",
    "lczq":"Financial cycle",
    "dbxe":"Single remittance quota (USDT)",
    "pxsj":"Dividend payout time",
    "mr":"Daily",
    "dqfh":"Return when due",
    "tgzj":"Custody capital",
    "tqsh":"Early redemption",
    "yjsy":"Anticipated income (USDT)",
    "kyzc":"Available assets (USDT)",
    "cpjs":"About Our Products",
    "tgje":"Custody amount",
    "qsrtgje":"Enter the custody amount",
    "qb":"All",
    "rm":"Buy now",
    "cpzq":"Product cycle",
    "jxr":"Interest calculation",
    "jiexr":"Interest settlement",
    "yjdzr":"Estimated arrival date",
    "gz":"Know the rules and interests"
  },
  "bzhlwdtg":{
    "title":"Order status",
    "tgz":"In custody",
    "ywc":"Completed",
    "ysh":"Redeemed",
    "tgje":"Custody amount/Custody time",
    "rsyl":"Daily return rate",
    "yhl":"Profited",
    "xdsj":"Ordering time",
    "sh":"Redemption",
    "ddxq":"Order details",
    "ddh":"Order Number "
  },
  "bzjj":{
    "t1": "Earn every day",
    "t2": "Brick removal is a process which transfers USDT to the platform, and professional platform teams have the authority to move bricks. Participants can share part of the platform's brick removal income during the capital custody period.",
    "cpld": "Product highlights",
    "scsq": "Deposit&take anytime",
    "pxzq": "Dividend cycle",
    "mtxf": "Distribute daily",
    "hqlx": "Current interest",
    "zj": "100% fund",
    "aqbz" :"Security",
    "jjrsy": "Holiday earnings",
    "sybjd": "Continuous profit",
    "bjd": "Uninterrupted",
    "cgcrh": "After successful deposit",
    "dtqx": "Interest value on the day",
    "jglz": "For example",
    "syjs": "Calculation of revenue",
    "cont1": "If a members has deposited 10,000 U on the platform and selected financial products with a maturation cycle of seven days and a daily return rate of 0.3-0.5%, then the daily return is as follows: ",
    "cont2": "Minimum: 10,000 U*0.3%=30U",
    "cont3": "Maximum: 10,000 U*0.5%=50U",
    "cont4": "Namely, After 7 days, you can receive 210-350 U of income. This income will be distributed daily, and distributed income can be accessed at any time. The principal will automatically return to your wallet account after the expiration of the period.",
    "gywyj": "About liquidated damages",
    "cont5": "If you want to transfer out the undue principal, you will be subject to liquidated damages, which equals to default settlement ratio, multiplied by the remaining days, multiplied by the investment Qty.",
    "cont6": "For example: If the default settlement ratio of the product is 0.4%, and is due to mature in 3 days, with an investment Qty. of 1000, then the liquidated damages= 0.4%*3*1000=12 U, and the actual returned principal will be 1000 U-12 U=988 U",
    "wycy": "I want to join"
  },
  "zyzs":{
    "title":"Take profit & stop loss",
    "zy":"Take profit",
    "zs":"Stop loss",
    "qsrzyjg":"Enter a Take Profit price",
    "qsrzsjg":"Enter a Stop loss price",
    "cfjglx":"Trigger Price Type:",
    "zsjg":"Index price",
    "scjg":"Market price",
    "pcfs":"Methods to Close positions:",
    "kpcw":"Closeout",
    "qbcw":"All positions",
    "wxts":"Please note:",
    "cont": "The Close positions of the market price may create the possibility of failing to make an order at market price, or to successfully take profit/stop loss due to sharp market fluctuations and other problems.",
    "qr":"OK"
  },
  "bbjy":{
    "mr":"Buy",
    "mc":"Sell",
    "mai":"Purchase",
    "sell":"Sell",
    "xj":"Limit",
    "sj":"Market",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty.",
    "ss":"Qty.",
    "mrl":"Buying Vol.",
    "mcl":"Selling Vol.",
    "ky":"Available",
    "km":"Available",
    "ksell":"Marketable",
    "jye":"Turnover",
    "dqwt":"Current entrustment",
    "lswt":"Historical entrustment",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading Vol.",
    "cjjj":"Average transaction price",
    "cd":"Withdraw",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuing date",
    "fhsl":"Issuing Number",
    "bps":"White Paper",
    "gw":"Official Website",
    "qx":"Cancel"
  },
  "hyjy":{
    "mai":"Purchase",
    "sell":"Sell",
    "kc":"Open positions",
    "pc":"Close positions",
    "cc":"Positions",
    "kp":"Close",
    "kpc":"Close short",
    "kcc":"Positions",
    "kkd":"Open long",
    "kpd":"Long close",
    "kkk":"Open short",
    "xj":"Limit",
    "sj":"Market",
    "xjwt":"Limit order",
    "sjwt":"Market price",
    "pk":"Position",
    "jg":"Price",
    "sl":"Qty.",
    "gg":"Lever",
    "tzgg":"Control lever",
    "ggbs": "Leverage",
    "mrl":"Buying Vol.",
    "ky":"Available",
    "jye":"Turnover",
    "dqwt":"Current entrustments",
    "lswt":"Historical entrustment",
    "ptwt":"Ordinary entrustments",
    "dqwtmr":"Current entrustments(Buy)",
    "dqwtmc":"Current entrustments(Sell)",
    "hywt":"Contract entrustments",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Entrustment price",
    "ycjl":"Completed trading Vol.",
    "cjjj":"Average transaction price",
    "qbcd":"Withdraw all orders",
    "cd":"Withdraw",
    "xd":"Order",
    "wqcj":"A complete deal",
    "ywc":"Completed",
    "ycd":"Cancelled order",
    "zx":"Favorites",
    "scjg":"Market price",
    "fhsj":"Issuance date",
    "fhsl":"Issuance Number",
    "bps":"White Paper",
    "gw":"Official website",
    "mrzd":"Long open",
    "mrpk":"Short close",
    "mczk":"Short open",
    "mcpd":"Long close",
    "mrkdkz":"Long open (Bullish)",
    "mrpkkz":"Short close (Bullish) ",
    "mckkkd":"Short open (Bearish)",
    "mcpdkd":"Long close (Bearish)",
    "yxhy":"Perpetual contract",
    "dc":"Long positions",
    "kcjj":"Open position average price(USDT)",
    "wsxyl":"Unrealized profit(USDT)",
    "ygqpj":"Estimated strong parity(USDT)",
    "syl":"Rate of return",
    "cwbzj":"Position margin(USDT)",
    "cw":"Positions (Number)",
    "cwjz":"Position value(USDT)",
    "bzjl":"Margin rate",
    "kpz":"Close (Number) ",
    "bdzs":"Underlying index",
    "tzbzj":"Adjust margin",
    "zyzs":"Take profit & stop loss",
    "zjbzj":"Increase margin",
    "jsbzj":"Reduce margin",
    "tyhy":"Experience Contract",
    "ccz":"Position (Number)",
    "cwbzjt":"Position margin(TBTC)",
    "zdzjbzj":"Maximum margin increase(TBTC)",
    "zjbzjt":"Margin increase(TBTC)",
    "zhang":"Qty.",
    "qblx":"All Types",
    "qb":"All",
    "ccjg":"Positions price",
    "ccsl":"Positions Qty.",
    "yk":"Profit and loss",
    "ccsj":"Positions time",
    "zy":"Take profit",
    "zs":"Stop loss",
    "zje":"Total amount",
    "kcs":"Open positions Qty.",
    "kcjg":"Open positions price",
    "ss":"Lots",
    "hand":"1 lots =",
    "qx":"Cancel",
    "qr":"OK"
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Order",
    "cj":"Deal",
    "jj":"Info",
    "sj":"Time",
    "fx":"Direction",
    "jg":"Price",
    "sl":"Qty.",
    "mr":"Buy",
    "mc":"Sell",
    "mp":"Bid",
    "sp":"Selling",
    "slb":"Qty.",
    "fhsj":"Issuing date",
    "fhsl":"Issuing Number",
    "bps":"White Paper",
    "gw":"Official website",
    "fz":"Min",
    "xs":"Hour",
    "tian":"Day",
    "zhou":"Week",
    "yue":"Month",
    "gd":"More",
    "ft":"Subgraph",
    "zt":"Main graph",
    "sdt":"Depth image",
    "zx":"Favorites",
    "djck": "Click to view"
  },
  "zhjl":{
    "cbtb":"Deposit & Withdraw",
    "jymx":"Transaction details",
    "tgyj":"Promotion commission",
    "wwc": "Undone",
    "ywc": "Completed"
  },
  "zwsj":{
    "title":"No data"
  },
  "bzxz":{
    "title":"Token"
  },
  "jghy":{
    "jghy": "Contracts",
    "yxhy": "Perpetual",
    "mz": "Bullish",
    "md": "Bearish",
    "gmj": "Purchase price",
    "jsj": "Settlement price",
    "xj": "Latest price",
    "fx": "Direction",
    "sl": "Vol.",
    "jgsj": "Delivery time",
    "gb": "Close",
    "jxxd": "Continue to place an order",
    "cclb": "Order list",
    "zc": "Current",
    "lscc": "History",
    "qblx": "All",
    "yk": "Profit",
    "ddqr": "Order Confirmation",
    "dqsj": "Expire time",
    "jssj": "Delivery time",
    "sy": "Profit",
    "tzje": "Investment price",
    "zdje": "Lowest price 0",
    "kyye": "Balance: ",
    "kyye2": "Available",
    "sxf": "Fee: ",
    "sxfl": "Fee",
    "jypz": "Name",
    "jyfx": "Direction",
    "qrxd": "Confirm",
    "fs": "Line",
    "dqye": "Current balance"
  },
  "kjmb":{
    "title":"Crypto",
    "gm": "Buy USDT",
    "wxts": "Reminder:",
    "wxts-copy": "Copy the usdt address. You need to use this address to purchase usdt.",
    "copy": "Copy",
    "ljmb": "Buy Crypto",
    "buy": "Buy",
    "cs": "Sell",
    "qx": "Cancel",
    "gmsl": "Purchase amount",
    "cssl": "Amount sold",
    "qsrgmsl": "Enter the purchase amount",
    "qsrcssl": "Enter the sale amount",
    "qxzzffs": "Eelect mode of payment",
    "yhk": "Bank card",
    "wx": "Wechat",
    "zfb": "Alipay",
    "jg": "Price",
    "kyye": "Balance",
    "zxjysl": "Minimum Number of transactions",
    "ts1": "1.All merchants who buy and sell are platform-certified merchants and provide 24-hour service.",
    "ts2": "2.If there is a dispute about the order, please contact customer service immediately for handling.",
    "fzcg": "Copy successful"
  },
  "tips":{
    "jymm": "Transaction password",
    "szjymm": "Set transaction password",
    "qsrjymm": "Enter transaction password",
    "jymmts": "Please go to the Security Center to set the transaction password"
  },
  "xyf":{
    "title": "Credit score",
    "pgsj": "Evaluation time"
  },
  "dzrz":{
    "title": "Address authentication",
    "sdddz":"Utility bill address",
    "tpsc": "Bill image upload",
    "ts": "Reminder: You need to fill in the address information and submit the utility bill or broadband address bill",
    "tips":"You need to fill in the address information and submit the utility bill or broadband address bill",
    "qsczdtp":"Upload a picture of the bill"
  },
  "newReg":{
    "sjh": "Mobile",
    "yx": "Email",
    "yqm": "Invitation code",
    "yqm2": "Invitation code (optional)",
    "cjzh": "Create Account",
    "sysjhzyx": "Sign Up with mobile Number/email",
    "sj": "Mobile",
    "yhxy": "User Agreement&gt",
    "yhxy2": "I have read and agree to the  and  &lt;User Agreement&gt; "
  },
  "mbwt":{
    "title": "Security issues",
    "mbwt": "Security issues",
    "qtxda": "Fill in the answer",
    "qsrxmm": "Enter a new password",
    "sydqmmcz": "Use current password reset",
    "zhmm": "Security issues Retrieve password",
    "ysz": "Has been set",
    "tg": "Ignore",
    "tj": "Submit",
    "zyts": "Important:",
    "zytsCont": "Do not disclose the secret answer and verification code, and keep in mind the security issue, which will help you retrieve your password"
  },
  "xbsg":{
    "title": "New Coin Zone",
    "wdsg": "Details",
    "scts": "Lockup days: ",
    "sy": "Remaining",
    "ljsg": "Subscribe now",
    "ysk": "Sold out",
    "xzjdy": "Subscribe now",
    "dy": "Subscribe",
    "fxjg": "issue price",
    "fxl": "Circulation",
    "ssrq": "Listing date",
    "yxqx": "Validity period",
    "qsrsl": "Enter amount",
    "syl": "Remaining",
    "sgrq": "Subscribe",
    "sgsl": "Amount",
    "bz": "Coin",
    "yebz": "Insufficient USDT balance",
    "tgsl": "Pass Qty.",
    "shz": "Under review",
    "wtg": "Did not pass",
    "ytg": "Passed"
  },
  "wydb":{
    "title": "Borrow",
    "db": "Borrow",
    "dbz": "Borrow",
    "jl": "Details",
    "jdzq": "Period (days)",
    "qhk": "To repay",
    "ljdb": "Cumulative(USDT)",
    "dhkbs" :"Pending payment",
    "jkje": "Loan amount(USDT)",
    "qsrje": "Enter amount",
    "rll": "Daily interest rate",
    "hkfs": "Repayment",
    "dqych": "Expired",
    "lx": "Interest",
    "fkjg": "Lender",
    "tpsc": "Credit loan (image upload)",
    "fwxx": "Housing information",
    "srzm": "Proof of income (employment relationship)",
    "yhmx": "Bank statement",
    "zjz": "ID photo",
    "yd": "I have read and agreed",
    "xy": "Apply for a loan agreement",
    "sqdb": "Click to apply for loan chains",
    "gb": "Close",
    "qd": "OK",
    "ts": "Check Apply for a loan agreement",
    "dbjl": "Details",
    "hkhth": "Order Code",
    "wsh": "Unreviewed",
    "yfk": "Loan",
    "sqrq": "Application time",
    "zq": "Cycle",
    "dbsl": "Number of ribs",
    "zhke": "Total payment",
    "yhkxq": "Repayment Details",
    "bqyhk": "Repayable in the current period(USDT)",
    "hktips": "Please make sure the balance is sufficient, if the balance is insufficient, please recharge first and then repay",
    "bj": "Principal",
    "jie": "Borrow",
    "ljhk": "Repay immediately",
    "qcz": "Deposit",
    "yebzqxcz": "Insufficient balance, please recharge first and then repay",
    "znj": "Late payment fee",
    "yqts": "Days Overdue"
  },
  "hkxq":{
    "dd":"Order",
    "fzhkdz":"Copy the repayment address",
    "hkxq": "Repayment Details",
    "zlx": "Total interest",
    "zhk": "Total repayments",
    "hkjg": "Repayment agency",
    "qschkpz": "Upload the repayment certificate",
    "hkpz": "Repayment certificate"
  },
  "bbjyNew":{
    "jylx": "Types of",
    "jyze": "Amount"
  },
  "indexNew":{
    "title": "Add Starspu to the main interface",
    "t1": "Quick access to full screen experience",
    "t2": "Click on the toolbar below",
    "t3": "And select",
    "t4": "Add to Home Screen",
    "t5": "Add to desktop experience full version of Starspu" ,
    "t6": "Add to Favourites",
    "t7": "Find on Page"
  },
  "bind":{
    "title": "Email Authentication",
    "ybd": "Bound",
    "wbd": "Unbound",
    "yrz": "Verified",
    "wrz": "Unverified",
    "ts": "To protect your account, it is recommended to bind an Email",
    "qsryxdz": "Email"
  },
  "status":{
    "statusText": ['failure','under review','success'],
 },
 "tipsNew":{
   "wjmmts": "Recover password by verification code",
   "qscpztp": "Upload the voucher image",
   "emailgsts": "Input Emailes do not conform to the rules",
   "telgsts": "The mobile phone Number is incorrect",
   "lcmmbyz": "Confirm your password",
   "zdsl": "Min Qty. ",
   "sldydy": "Qty. greater than or equal to",
   "zxtzsl": "Min Qty.",
   "ddz": "Waiting",
   "xs": "Hour",
   "min": "Minimum amount ",
   "max": "Maximum amount ",
   "yebz": "Insufficient balance",
   "qsrss": "Input lots",
   "zdss": "Minimum lots",
   "yjj": "Rejected",
   "shz": "Redemption",
   "zwkfcz": "This Coins is not open for deposit",
   "jiaoge": "Delivery",
  "zhang": "Buy long",
  "die": "Buy short",
  "cjxnzh": "Create demo account"
 },
 "langNew2":{
  "flzq": "Rewards Hub",
  "qdjl": "Sign In reward",
  "mrqdjl": "Daily sign-in reward",
  "qd": "Sign In",
  "yqd": "Signed in",
  "hdgz": "Event Rules",
  "qdjl2": "Check-in Details",
  "qdcg": "Sign In successfully",
  "yhd": "Acquired",
  "lq": "Receive",
  "dyt": "Day 1",
  "det": "Day 2",
  "dst": "Day 3",
  "dsit": "Day 4",
  "dwt": "Day 5",
  "dlt": "Day 6",
  "dqt": "Day 7",
  "jxz": "In progress"
},
"langNew":{
  "kp": "Opening",
  "zuoshou": "Received yesterday",
  "zg": "Highest",
  "zd": "Lowest",
  "dqjg": "Latest price",
  "pcjg": "Closing price",
  "gd": "pending order",
  "gdj": "Pending order price",
  "gdjg": "Pending order price",
  "xfbzj": "Security deposit required: ",
  "ksrfw": "Available input range: ",
  "shou": "Lots",
  "fdjyk": "Floating net profit and loss",
  "pcsl": "Closing Qty.",
  "cx": "Revoke",
  "qrpc": "Confirm to close the position",
  "sx": "Filter",
  "cz": "Reset",
  "zdl": "Know",
  "kccg": "Successfully opened a position!",
  "xzfx": "Choose direction",
  "lx": "Type",
  "xgcc": "Modify position",
  "szzyzs": "Set stop profit and stop loss",
  "szhb": "Crypto",
  "gjs": "Metal",
  "yy": "Crude",
  "jy": "Trade",
  "jmhb": "Crypto",
  "gdsj": "Pending order time",
  "gdsl": "Pending Order Qty.",
  "fs": "Time"
 },
 "ieo":{
   "ieo": "IEO",
   "csjg": "Initial price",
   "syl": "The remaining amount",
   "sjd": "Market order",
   "jj": "Average price",
   "zsl": "The total amount",
   "zyk": "Total profit and loss",
   "ljmr": "Buy now",
   "yqx": "Cancelled",
   "gmjl": "Purchase History",
   "yjs": "Over",
   "jzrq": "Expiration date",
   "xjcz": "Cash recharge",
   "djlxkf": "If you use Japanese yen to deposit money, please click to contact customer service",
   "qrrjts": "If you use USD to deposit, please contact customer service",
   "mmts": "Only uppercase and lowercase letters plus Numbers are allowed"
  },
  "langNew4":{
    "qsrndzh": "Enter your account Number",
    "ljcb": "Deposit",
    "ljtb": "Withdraw",
    "flhd": "Welfare activities",
    "flzx": "Welfare center",
    "lqjl": "Get the highest reward",
    "wyzq": "I have earned",
    "hdlb": "Events List",
    "dk": "Loan",
    "kyje": "Amount Available",
    "je": "Amount",
    "zd": "Maximum",
    "wxj": "I want to borrow...",
    "dkjl": "Loan history",
    "xydk": "Credit Loans",
    "tpsc": "Upload picture",
    "dkts": "No interest is required for 3 days after the loan is taken, and interest will be paid thereafter",
    "ljdk": "Loan now",
    "qwc": "To complete"
  },
  share:{
    "hd": "Get Crypto rewards",
    "yqhy": "Invite your friends to participate in Ai quantification, rent mining machines, and trade products to get Crypto rewards",
    "yqsy": "Invitation income",
    "yqrs": "Number of people invited",
    "yqlj": "Invite via link",
    "lj": "Link",
    "yqm": "Invitation code",
  },
  myAssets:{
    "cz": "Deposit",
    "wzh": "Deposit digital Coins or legal Coins into your account",
    "tx": "Withdraw",
    "xyzh": "Withdraw assets from existing accounts to your bank card or wallet",
  },
  user:{
    "zcgl": "Assets",
    "xb": "New Coins",
    "hd": "Activities and Rewards",
    "zhxg": "Account related",
    "kf": "Customer service",
    "sfrz": "Authentication",
    "aq": "Security",
    "gy": "About",
    "sz": "Settings",
    "gp": "Stock",
    "wh": "Foreign Exchange"
  },
  "langNew3":{
    "xw":"News",
    "gdgnjxz":"Copy order function is in progress",
    "gdts":"Start copying orders, high yields, high returns, allowing you to earn coins without any effort",
    "ksgd":"Start copying",
    "gd":"Follow",
    "gdlx1":"AI GPT",
    "gdlx2":"Politician",
    "gdlx3":"Trader",
    "npjsy":"Average annual income",
    "gtrs":"Number of follow-up investors",
    "hbl":"Rate of Return",
    "gtje":"Follow-up investment amount",
    "gt":"Follow-up investment",
    "gdz":"Following",
    "ywc":"Completed",
    "zdf":"Rise and fall",
    "tz":"Stop",
    "bdy":"No less than",
    "xwxq":"News details",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/en.js